import { createStore } from 'redux';
import { rootReducer } from './reducers';

const store = createStore(rootReducer);

export type StoreState = ReturnType<typeof store.getState>
export type StoreDispatch = typeof store.dispatch;

export default store;
